module.exports = __webpack_public_path__ + "static/media/downloadGreen.04434377.svg";